import { CELL_SETS_UNHIDE_ALL } from '../../actionTypes/cellSets';
var unhideAllCellSets = function unhideAllCellSets() {
  return function (dispatch) {
    dispatch({
      type: CELL_SETS_UNHIDE_ALL
    });
  };
};
export default unhideAllCellSets;